var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M9.55 17.277a.828.828 0 0 1-.633-.256l-4.175-4.175a.701.701 0 0 1-.21-.534.754.754 0 0 1 .226-.535.717.717 0 0 1 .527-.217c.206 0 .382.072.527.217l3.738 3.738 8.639-8.638a.727.727 0 0 1 .534-.217c.212 0 .39.072.535.217a.726.726 0 0 1 .217.535c0 .211-.072.39-.217.534l-9.075 9.075a.828.828 0 0 1-.633.256Z",
    fill: "currentColor"
  })));
};
export default SvgCheck;